(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/favorites/assets/javascripts/views/favoritestar.js') >= 0) return;  svs.modules.push('/components/sport/favorites/assets/javascripts/views/favoritestar.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs = svs || {};
  svs.sport = svs.sport || {};
  svs.sport.views = svs.sport.views || {};

  svs.sport.views.FavoriteStar = Backbone.View.extend({
    defaults: function() {
      this.model = null;
      this.favoriteData = {};
      this.hasFavorites = false;
      this.toggleAfterLogin = false;
    },

    initialize: function(options) {
      this.sport = options.sport || svs.sportservice.app;
      this.initListeners(this.sport);
      this.initFavoriteData();

      if (
        !!this.sport &&
        svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)
      ) {
        this.onGetFavorites(new svs.sport.favorites.models.Favorites());
      }
    },

    initListeners: function() {
      if (this.sport) {
        this.listenTo(this.sport, 'init-favorites', this.onInitFavorites);
        this.listenTo(this.sport, 'get-favorites', this.onGetFavorites);
        this.listenTo(this.sport, 'change-favorites', this.onChangeFavorites);
        this.listenTo(this.sport, 'remove-favorites', this.onRemoveFavorites);
      }
    },

    onInitFavorites: function(favorites) {
      this.model = favorites;
    },

    onGetFavorites: function(favorites) {
      this.model = favorites;
      this.listenTo(this.model, 'reset', this.onModelReset);
      this.checkHasFavorites();
    },

    onModelReset: function() {
      this.checkHasFavorites();
      this.render();
    },

    onChangeFavorites: function(hasChanged, favorites) {
      this.model = favorites;
      this.checkHasFavorites();
      if (this.toggleAfterLogin) {
        this.toggleAfterLogin = false;
        if (!this.hasFavorites) {
          this.clickFavorite();
        }
      }
    },

    onRemoveFavorites: function() {
      this.doLogout();
    },

    initFavoriteData: function() {
      if (this.options.league) {
        this.favoriteData = {
          league: {
            id: this.options.league
          },
          team: { id: 0 }
        };
      } else if (this.options.team) {
        this.favoriteData = {
          league: { id: 0 },
          team: {
            id: this.options.team
          }
        };
      }
    },

    checkHasFavorites: function() {
      var oldstate = this.hasFavorites;
      this.hasFavorites =
        this.model.leagues.findWhere({
          LeagueId: parseInt(this.favoriteData.league.id, 10)
        }) ||
        this.model.teams.findWhere({
          TeamId: parseInt(this.favoriteData.team.id, 10)
        });

      this.hasFavorites = !!this.hasFavorites;

      if (oldstate !== this.hasFavorites) {
        this.trigger('change');
      }
    },

    clickFavorite: function() {
      if (
        this.model &&
        svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)
      ) {
        this.toggleSingleFavorite();
      } else if (
        !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)
      ) {
        this.toggleAfterLogin = true;
        this.doLogin();
      } else {
        this.sport.execute('get-favorites');
      }
    },

    toggleSingleFavorite: function() {
      var favoriteModel;
      if (this.favoriteData.league.id) {
        if (
          this.model.leagues.findWhere({
            LeagueId: parseInt(this.favoriteData.league.id, 10)
          })
        ) {
          favoriteModel = this.model.leagues.findWhere({
            LeagueId: parseInt(this.favoriteData.league.id, 10)
          });
          this.model.leagues.remove(favoriteModel);
        } else {
          this.model.leagues.add(
            new this.model.leagues.model({
              favoriteOrder: this.model.leagues.length,
              LeagueId: this.favoriteData.league.id
            })
          );
        }
        this.model.save();
      } else if (this.favoriteData.team.id) {
        if (
          this.model.teams.findWhere({
            TeamId: parseInt(this.favoriteData.team.id, 10)
          })
        ) {
          favoriteModel = this.model.teams.findWhere({
            TeamId: parseInt(this.favoriteData.team.id, 10)
          });
          this.model.teams.remove(favoriteModel);
        } else {
          this.model.teams.add(
            new this.model.teams.model({
              TeamId: parseInt(this.favoriteData.team.id, 10)
            })
          );
        }
        this.model.save();
      }
      svs.sport.views.GameFavoriteGlobalEvents.trigger(
        'change-favorites',
        true,
        this
      );
    },

    render: function() {
      var isSelfService = svs.utils.ns.isNamespace(
        'svs.core.config.data.svsconfig.isSelfService'
      )
        ? svs.core.config.data.svsconfig.isSelfService
        : false;
      if (!isSelfService) {
        return svs.sport.favorites.templates.favorite_button({
          hasFavorites: false
        });
      }
    },

    doLogin: function() {
      svs.components.customer_login.login();
    },

    doLogout: function() {
      if (this.model) {
        this.model = null;
        this.hasFavorites = false;
        this.trigger('change');
      }
    },

    onClose: function() {
      this.doLogout();
      this.stopListening(this.sport);
    }
  });
})(Backbone, _, svs);

 })(window);